<template>
    <div :class="[disabled ? 'cursor-not-allowed' : null]">
        <froala
            :tag="'textarea'"
            v-if="loaded"
            :config="config"
            :value="content"
            @input="onInput"
        ></froala>
        <input type="hidden" :value="content" :name="name" />
    </div>
</template>

<script>
import siteLanguage from '../config/siteLanguage'
import {useDarkModeStore} from "../stores/darkMode";

export default {
    name: "content-editor",
    props: {
        value: String,
        id: String,
        contentData: String,
        name: String,
        toolbarButtons: {
            type: Array,
            required: false,
            default: () => [
                'rocketLink',
                'italic',
                'formatOL',
                'formatUL',
                'bold',
                'underline',
                'strikeThrough',
                'subscript',
                'superscript',
                'undo',
                'redo',
                'clearFormatting',
                'html'
            ],
        },
        tableMaxCols: {
            type: Number,
            required: false,
            default: 10,
        },
        language: {
            type: Object,
            default: () => ({ iso: siteLanguage.iso.ENGLISH }),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        maxlength: {
            type: Number,
            required: false,
        },
    },
    data() {
        return {
            loaded: false,
            content: this.contentData,
            config: {
                disabled: true,
                key: process.env.MIX_FROALA_KEY,
                toolbarButtons: this.toolbarButtons,
                paragraphFormat: {
                    N: "Paragraph",
                    H3: "Heading 3",
                    H4: "Heading 4",
                    H5: "Heading 5",
                    H6: "Heading 6",
                },
                theme: null,
                pastePlain: false,
                linkNoOpener: false,
                linkNoReferrer: false,
                quickInsertEnabled: false,
                imageDefaultWidth: 0,
                imageUpload: false,
                imageBrowse: false,
                imageDefaultAlign: "left",
                imageInsertButtons: ["imageManager"],
                imageManagerLoadURL: route(
                    "api.media.index",
                    this.language.iso
                ),
                imageEditButtons: [
                    "imageRemove",
                    "imageAlt",
                    "imageLink",
                    "linkOpen",
                    "linkEdit",
                    "linkRemove",
                    "imageAlign"
                ],
                imageManagerPageSize: 5,
                linkMultipleStyles: false,
                linkStyles: {},
                tableResizer: false,
                tableEditButtons: [
                    "tableHeader",
                    "|",
                    "tableRemove",
                    "|",
                    "tableRows",
                    "-",
                    "tableColumns",
                    "|",
                    "tableCells",
                    "|",
                    "tableCellVerticalAlign",
                    "-",
                    "tableCellHorizontalAlign"
                ],
                tableInsertMaxSize: this.tableMaxCols,
                events: {
                    "image.inserted": function (img) {
                        img[0].alt = img[0].dataset.alt;
                        img[0].longDesc = img[0].dataset.long_description;
                        Object.keys(img[0].dataset).forEach((dataset) => {
                            img[0].removeAttribute(`data-${dataset}`);
                        });
                    },
                    focus: (e) => {
                        if (this.disabled) {
                            setTimeout(() => e.target.blur(), 1);
                        }
                    },
                },
                pluginsEnabled: ['rocketLink', 'rocketPaste', 'table', 'lists', 'codeView', 'charCounter', 'image'],
                rocketLinkLanguageId: this.language.id || undefined,
                charCounterMax: this.maxlength || -1,
            },
        };
    },
    mounted() {
        if (useDarkModeStore().darkMode) {
            this.config.theme = 'dark';
        }

        this.loaded = true;
    },
    methods: {
        onInput(value) {
            if (this.disabled) {
                return
            }

            this.content = value;

            this.$emit("input", value);
        }
    },
    watch: {
        value: function (val) {
            this.content = val;
        },
    },
};
</script>
